import { observer } from 'mobx-react-lite';
import { Link } from 'react-router';
import { useStore } from '@link/admin/stores';
import adminAuth from '@link/admin/vendors/firebase';
import { EnvBadge, Locale, User } from '@link/share/components';
import { clearAutoLogoutStorage } from '@link/share/hooks';
import { linktivity } from '@link/share/icons';
import styles from './header.module.css';

const HeaderView: React.FC = () => {
  const { auth } = useStore();

  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <div className={styles.brand}>
          <Link to="/" className={styles.logo}>
            <img src={linktivity} alt="logo" width="160" />
          </Link>
          <EnvBadge />
        </div>
        <div className={styles.right}>
          <Locale />
          <User
            email={auth.user?.email || ''}
            logout={() => {
              clearAutoLogoutStorage();
              adminAuth.logout();
            }}
          />
        </div>
      </div>
    </header>
  );
};
const Header = observer(HeaderView);
export default Header;
